import { combineReducers } from 'redux';
import { GET_TELEMATIC_CONNECTION_CREATION_ATTEMPT } from '../../actions';

const loadingReducer = (state = false, { type }) => {
  switch (type) {
    case GET_TELEMATIC_CONNECTION_CREATION_ATTEMPT.START:
      return true;
    case GET_TELEMATIC_CONNECTION_CREATION_ATTEMPT.SUCCESS:
    case GET_TELEMATIC_CONNECTION_CREATION_ATTEMPT.FAIL:
      return false;
    default:
      return state;
  }
};

const dataReducer = (state = null, { type, payload }) => {
  switch (type) {
    case GET_TELEMATIC_CONNECTION_CREATION_ATTEMPT.START:
      return null;
    case GET_TELEMATIC_CONNECTION_CREATION_ATTEMPT.SUCCESS:
      return payload.data || null;
    default:
      return state;
  }
};

export default combineReducers({
  loading: loadingReducer,
  data: dataReducer,
});
